// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/analytics/DataSourcesPieChartLegend.scss
// module id = 1278
// module chunks = 0